import React, { useCallback, useMemo } from 'react'
import styled from 'styled-components';
import { addElement, removeElementById } from '../../globalStates/utils';
import { Coupons, EMPTY_COUPON, useExhibitorDataState } from '../../globalStates/ExhibitorDataState';
import { addValidatorsCoupon } from '../../globalStates/ExhibitorValidation';
import { useLanguageState } from '../../globalStates/LanguageState';
import { useConfigDataState } from '../../globalStates/ConfigDataState';
import { newId } from '../../utils/Id';
import Page from '../../components/Page';
import Button from '../../components/Button';
import CouponsSection from './CouponsSection';

const ButtonsBar = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
`

const CouponsPage: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const serviceKeys = useConfigDataState().getServiceKeys()
    const couponsLimit = serviceKeys.goodies || 10
    const couponsStates = useExhibitorDataState().getCoupons()
    const canAddCoupons = useMemo(() => {
        if (couponsStates.length >= couponsLimit) return false
        let valid = true;
        couponsStates.forEach(couponsState => {
            const name = couponsState.name.get()
            valid = valid && !!name && name.length >= 0
        });
        return valid
    }, [couponsLimit, couponsStates])

    const couponsDateStart = branding.configuration.couponsPage.sctCoupons.dateCouponsValidStart
    const couponsDateEnd = branding.configuration.couponsPage.sctCoupons.dateCouponsValidEnd

    const onAddCoupons = useCallback(() => {
        addElement<Coupons>(couponsStates, { ...EMPTY_COUPON, validStart: couponsDateStart ? new Date(couponsDateStart.toString()) : new Date(), validEnd: couponsDateEnd ? new Date(couponsDateEnd.toString()) : new Date(), id: newId().toString() });
        addValidatorsCoupon(couponsStates[couponsStates.length - 1])
    }, [couponsStates, couponsDateStart, couponsDateEnd])

    const onRemoveCoupons = useCallback((productId: string) => {
        removeElementById<Coupons>(couponsStates, productId)
    }, [couponsStates])

    return (
        <Page
            title={branding.configuration.couponsPage.pageTitle}
            description={branding.configuration.couponsPage.pageDescription}>

            {couponsStates?.map((couponsStates, index) => (<CouponsSection key={couponsStates.id.get()} couponsState={couponsStates} index={index} onClickRemove={onRemoveCoupons} />))}

            <ButtonsBar>
                <Button id='addCoupons' caption={branding.configuration.couponsPage.btnAddCoupons} inverse onClick={onAddCoupons} disabled={!canAddCoupons} />
            </ButtonsBar>
        </Page>
    );
}

export default CouponsPage